export default class PlayerVersionValidation {
    static validate(player_policy, player_version) {
        this.is_live = player_policy.is_live;
        this.os = player_policy.os;
        this.browser = player_policy.browser;
        return this[player_version]();
    }

    static v2() {
        return !this.is_live;
    }

    static v3() {
        return !this.is_live;
    }

    static v3e() {
        if (this.os.name !== 'Windows') return false;

        return 'v3e';
    }

    static v4() {
        return 'v4';
    }

    static v4a() {
        if (this.os.name !== 'Windows') return false;
        if (this.browser.name === 'IE' && Number(this.browser.major) <= 10) {
            return false;
        }
        return 'v4a';
    }

    static v5() {
        return 'v5';
    }

    static v5a() {
        if (this.os.name !== 'Windows') return false;
        if (this.browser.name === 'IE' && Number(this.browser.major) <= 10) {
            return false;
        }
        return 'v5a';
    }

    static ios() {
        if (this.os.name !== 'iOS') return false;

        return 'ios';
    }

    static android() {
        if (this.os.name !== 'Android') return false;

        return 'android';
    }

    static mac() {
        if (this.os.name !== 'Mac OS') return false;

        return 'mac';
    }
}
